import { IconButtonEmbed } from "components";
import { FC, MouseEvent } from "react";
import { switchAssetMode } from "../api";
import { usePack, useRunSync } from "lib/hooks";

export const QuickActionEmbed: FC<{ asset: any }> = ({ asset }) => {
  const { sync } = useRunSync(asset.pack_id);
  const { data: pack } = usePack(asset.pack_id);

  const toggleDisplay = async (e: MouseEvent): Promise<void> => {
    e.stopPropagation();
    try {
      await switchAssetMode(asset, pack.key);
      await sync();
      // TODO: Success notification
    } catch (e) {
      // TODO: Error notification
    }
  }

  return (
    <IconButtonEmbed isEmbedded={!!asset.data.embedded} onClick={toggleDisplay} />
  )
}
